import { ExportBiRun, Identifiable, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getExportBiRun(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Planzone>, runId: string) =>
    httpClient.sendHttpRequest<ExportBiRun>({
      endpoint: `/admin/exports/planzones/${uuid}/runs/${runId}`,
      method: HttpMethods.GET,
    });
}

export { getExportBiRun };
